import { FC } from 'react';
import { PageTitle } from '../../../rbts/layout/core';
import { View } from './components/View';

const EstatusChatPage: FC = () => {
  

  return (
    <>
      <PageTitle>{`${'Estatus del Chat'}`}</PageTitle>
      <View />
    </>
  );
};

export { EstatusChatPage };
